/**
 * All reducers should be added here so that Redux can use them.
 *
 * See https://github.com/hozana/hozana.org-v2/blob/develop/docs/3-functionnalities/redux.md
 */

import { apiReducer } from '@hozana/api/reducer'
import { GlobalActionTypes } from '@hozana/redux/constants'

import type { TState } from 'config/types'
import { appReducer } from 'general/reducer'

import { intentionReducer } from 'modules/intention/reducer'

const reducers = {
  api: apiReducer,
  app: appReducer,
  intention: intentionReducer,
}

export const getInitialState = (): TState =>
  Object.entries(reducers).reduce(
    (acc, [key, reducer]) => ({ ...acc, [key]: reducer(undefined, { type: GlobalActionTypes.NONE }) }),
    {} as TState,
  )

export default reducers
